/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Fairusefactors_Noncommercial3Inputs */

const id_privacy_fairusefactors_noncommercial3 = /** @type {(inputs: Privacy_Fairusefactors_Noncommercial3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tujuan Non-Komersial, Edukasi:`)
};

const ms_privacy_fairusefactors_noncommercial3 = /** @type {(inputs: Privacy_Fairusefactors_Noncommercial3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tujuan Bukan Komersial, Pendidikan:`)
};

const da_privacy_fairusefactors_noncommercial3 = /** @type {(inputs: Privacy_Fairusefactors_Noncommercial3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ikke-kommercielt, Uddannelsesformål:`)
};

const de_privacy_fairusefactors_noncommercial3 = /** @type {(inputs: Privacy_Fairusefactors_Noncommercial3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nicht-kommerzieller, Bildungszweck:`)
};

const en_us2_privacy_fairusefactors_noncommercial3 = /** @type {(inputs: Privacy_Fairusefactors_Noncommercial3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non-Commercial, Educational Purpose:`)
};

const es_es2_privacy_fairusefactors_noncommercial3 = /** @type {(inputs: Privacy_Fairusefactors_Noncommercial3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Propósito no comercial, educativo:`)
};

const es_mx2_privacy_fairusefactors_noncommercial3 = /** @type {(inputs: Privacy_Fairusefactors_Noncommercial3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Propósito no comercial, educativo:`)
};

const fil_privacy_fairusefactors_noncommercial3 = /** @type {(inputs: Privacy_Fairusefactors_Noncommercial3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Di-komersyal, Pang-edukasyon na Layunin:`)
};

const fr_privacy_fairusefactors_noncommercial3 = /** @type {(inputs: Privacy_Fairusefactors_Noncommercial3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usage non commercial et éducatif :`)
};

const it_privacy_fairusefactors_noncommercial3 = /** @type {(inputs: Privacy_Fairusefactors_Noncommercial3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scopo non commerciale, educativo:`)
};

const hu_privacy_fairusefactors_noncommercial3 = /** @type {(inputs: Privacy_Fairusefactors_Noncommercial3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nem kereskedelmi, oktatási cél:`)
};

const nl_privacy_fairusefactors_noncommercial3 = /** @type {(inputs: Privacy_Fairusefactors_Noncommercial3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niet-commercieel, educatief doel:`)
};

const no_privacy_fairusefactors_noncommercial3 = /** @type {(inputs: Privacy_Fairusefactors_Noncommercial3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ikke-kommersielt, pedagogisk formål:`)
};

const pl_privacy_fairusefactors_noncommercial3 = /** @type {(inputs: Privacy_Fairusefactors_Noncommercial3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cel niekomercyjny, edukacyjny:`)
};

const pt_br2_privacy_fairusefactors_noncommercial3 = /** @type {(inputs: Privacy_Fairusefactors_Noncommercial3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finalidade educacional não comercial:`)
};

const pt_privacy_fairusefactors_noncommercial3 = /** @type {(inputs: Privacy_Fairusefactors_Noncommercial3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fim não comercial, educativo:`)
};

const ro_privacy_fairusefactors_noncommercial3 = /** @type {(inputs: Privacy_Fairusefactors_Noncommercial3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scop necomercial, educațional:`)
};

const fi_privacy_fairusefactors_noncommercial3 = /** @type {(inputs: Privacy_Fairusefactors_Noncommercial3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ei-kaupallinen, koulutuksellinen tarkoitus:`)
};

const sv_privacy_fairusefactors_noncommercial3 = /** @type {(inputs: Privacy_Fairusefactors_Noncommercial3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Icke-kommersiellt, utbildningssyfte:`)
};

const vi_privacy_fairusefactors_noncommercial3 = /** @type {(inputs: Privacy_Fairusefactors_Noncommercial3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mục đích phi thương mại, giáo dục:`)
};

const tr_privacy_fairusefactors_noncommercial3 = /** @type {(inputs: Privacy_Fairusefactors_Noncommercial3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ticari Olmayan, Eğitim Amaçlı:`)
};

const cs_privacy_fairusefactors_noncommercial3 = /** @type {(inputs: Privacy_Fairusefactors_Noncommercial3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nekomerční, vzdělávací účel:`)
};

const bg_privacy_fairusefactors_noncommercial3 = /** @type {(inputs: Privacy_Fairusefactors_Noncommercial3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Некомерсиална, образователна цел:`)
};

const ru_privacy_fairusefactors_noncommercial3 = /** @type {(inputs: Privacy_Fairusefactors_Noncommercial3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Некоммерческая образовательная цель:`)
};

const uk_privacy_fairusefactors_noncommercial3 = /** @type {(inputs: Privacy_Fairusefactors_Noncommercial3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Некомерційна, освітня мета:`)
};

const ar_privacy_fairusefactors_noncommercial3 = /** @type {(inputs: Privacy_Fairusefactors_Noncommercial3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`غرض غير تجاري وتعليمي:`)
};

const hi_privacy_fairusefactors_noncommercial3 = /** @type {(inputs: Privacy_Fairusefactors_Noncommercial3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`गैर-वाणिज्यिक, शैक्षिक उद्देश्य:`)
};

const th_privacy_fairusefactors_noncommercial3 = /** @type {(inputs: Privacy_Fairusefactors_Noncommercial3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`วัตถุประสงค์ที่ไม่ใช่เชิงพาณิชย์และการศึกษา:`)
};

const ja_privacy_fairusefactors_noncommercial3 = /** @type {(inputs: Privacy_Fairusefactors_Noncommercial3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`非営利・教育目的：`)
};

const zh_cn2_privacy_fairusefactors_noncommercial3 = /** @type {(inputs: Privacy_Fairusefactors_Noncommercial3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`非商业性、教育目的：`)
};

const zh_hant1_privacy_fairusefactors_noncommercial3 = /** @type {(inputs: Privacy_Fairusefactors_Noncommercial3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`非商業性、教育目的：`)
};

const ko_privacy_fairusefactors_noncommercial3 = /** @type {(inputs: Privacy_Fairusefactors_Noncommercial3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`비상업적, 교육적 목적:`)
};

/**
* | output |
* | --- |
* | "Non-Commercial, Educational Purpose:" |
*
* @param {Privacy_Fairusefactors_Noncommercial3Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const privacy_fairusefactors_noncommercial3 = /** @type {((inputs?: Privacy_Fairusefactors_Noncommercial3Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Fairusefactors_Noncommercial3Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_privacy_fairusefactors_noncommercial3(inputs)
	if (locale === "ms") return ms_privacy_fairusefactors_noncommercial3(inputs)
	if (locale === "da") return da_privacy_fairusefactors_noncommercial3(inputs)
	if (locale === "de") return de_privacy_fairusefactors_noncommercial3(inputs)
	if (locale === "en-US") return en_us2_privacy_fairusefactors_noncommercial3(inputs)
	if (locale === "es-ES") return es_es2_privacy_fairusefactors_noncommercial3(inputs)
	if (locale === "es-MX") return es_mx2_privacy_fairusefactors_noncommercial3(inputs)
	if (locale === "fil") return fil_privacy_fairusefactors_noncommercial3(inputs)
	if (locale === "fr") return fr_privacy_fairusefactors_noncommercial3(inputs)
	if (locale === "it") return it_privacy_fairusefactors_noncommercial3(inputs)
	if (locale === "hu") return hu_privacy_fairusefactors_noncommercial3(inputs)
	if (locale === "nl") return nl_privacy_fairusefactors_noncommercial3(inputs)
	if (locale === "no") return no_privacy_fairusefactors_noncommercial3(inputs)
	if (locale === "pl") return pl_privacy_fairusefactors_noncommercial3(inputs)
	if (locale === "pt-BR") return pt_br2_privacy_fairusefactors_noncommercial3(inputs)
	if (locale === "pt") return pt_privacy_fairusefactors_noncommercial3(inputs)
	if (locale === "ro") return ro_privacy_fairusefactors_noncommercial3(inputs)
	if (locale === "fi") return fi_privacy_fairusefactors_noncommercial3(inputs)
	if (locale === "sv") return sv_privacy_fairusefactors_noncommercial3(inputs)
	if (locale === "vi") return vi_privacy_fairusefactors_noncommercial3(inputs)
	if (locale === "tr") return tr_privacy_fairusefactors_noncommercial3(inputs)
	if (locale === "cs") return cs_privacy_fairusefactors_noncommercial3(inputs)
	if (locale === "bg") return bg_privacy_fairusefactors_noncommercial3(inputs)
	if (locale === "ru") return ru_privacy_fairusefactors_noncommercial3(inputs)
	if (locale === "uk") return uk_privacy_fairusefactors_noncommercial3(inputs)
	if (locale === "ar") return ar_privacy_fairusefactors_noncommercial3(inputs)
	if (locale === "hi") return hi_privacy_fairusefactors_noncommercial3(inputs)
	if (locale === "th") return th_privacy_fairusefactors_noncommercial3(inputs)
	if (locale === "ja") return ja_privacy_fairusefactors_noncommercial3(inputs)
	if (locale === "zh-CN") return zh_cn2_privacy_fairusefactors_noncommercial3(inputs)
	if (locale === "zh-Hant") return zh_hant1_privacy_fairusefactors_noncommercial3(inputs)
	return ko_privacy_fairusefactors_noncommercial3(inputs)
});
export { privacy_fairusefactors_noncommercial3 as "privacy.fairUseFactors.nonCommercial" }